import { Fragment, useCallback } from 'react';
import styles from './labelValueColumn.module.scss';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

export const LabelValueColumn: React.FC<{
  options: {
    label: string;
    value: number | string | React.ReactElement;
  }[],
  className?: string;
}> = ({
  options,
  className
}) => {

  const renderContent = useCallback(() => (
    options.map((option) => (
      <Fragment key={option.label}>
        <div>{option.label}</div>
        <div style={{ whiteSpace: 'pre' }}>{` : `}</div>
        <div style={{ whiteSpace: 'pre-wrap' }}>{option.value}</div>
      </Fragment>
    ))
  ), [options]);

  return (
    <div className={cx(styles.labelValueColumn, className)}>
      {renderContent()}
    </div>
  );
};
